const regex = /(?<prefix>^.+?\*)\s?(?<exclude>.*?$)/i;
export type AsteriskMatchType = {prefix: string, exclude?: string};
export const getAsteriskPrefixAndIgnoreParts = (line: string) => {
	const match = regex.exec(line);
	if (match?.groups) {
		return match.groups as AsteriskMatchType
	}
	return null
}